<template>
  <div id="insurance">
    <loader v-if="loaderActive"></loader>
    <section class="insurance-banner">
      <div class="container">
        <div class="text-center">
          <h1 class="title">비즈해줌과 함께하면 <br>보험료가 더 저렴해집니다.</h1>
        </div>
        <div class="text-center">
          <button type="button" class="hz-btn-primary hz-btn-lg" @click="apply">보험 상담하기</button>
        </div>
      </div>
    </section>
    <section class="insurance-why">
      <div class="container text-center word-break-keep-all">
        <h2 class="content-title">태양광 설비, <br class="hidden-lg">25년 이상 보험없이 괜찮을까?</h2>
        <p class="content-text">아래 질문에 답할 수 없다면 <br>비즈해줌을 통한 보험이 꼭 필요합니다.</p>
        <ul class="row margin-top-48">
          <li class="col-md-4 col-xs-12">
            <div class="card">
              <div class="card-img-box">
                <img src="~@/assets/svg/insurance/insurance-why-01.svg" class="img-responsive" alt="Natural disaster insurance icon">
              </div>
              <div class="card-text-box">
                <p>태풍, 지진, 폭설 등으로 인한 <br>피해에 대비하고 있나요?</p>
              </div>
            </div>
          </li>
          <li class="col-md-4 col-xs-12">
            <div class="card">
              <div class="card-img-box">
                <img src="~@/assets/svg/insurance/insurance-why-02.svg" class="img-responsive" alt="Cheap insurance icon">
              </div>
              <div class="card-text-box">
                <p>다양한 혜택을 제공하는 <br>저렴한 보험을 찾으셨나요?</p>
              </div>
            </div>
          </li>
          <li class="col-md-4 col-xs-12">
            <div class="card">
              <div class="card-img-box">
                <img src="~@/assets/svg/insurance/insurance-why-03.svg" class="img-responsive" alt="Fly away panel icon">
              </div>
              <div class="card-text-box">
                <p>태풍으로 날아간 패널에 대한 <br>제 3자 피해도 대비하셨나요?</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="insurance-what">
      <div class="container text-center word-break-keep-all">
        <h2 class="content-title">그 어떤 보험보다 폭넓은 보장!</h2>
        <ul class="row card-wrap">
          <li class="col-md-4 col-xs-12">
            <div class="card">
              <div class="card-index">01</div>
              <div class="card-img-box">
                <img src="~@/assets/svg/insurance/insurance-what-01.svg" class="img-responsive" alt="Down price icon">
              </div>
              <div class="card-text-box">
                <h4>보험료, 자기부담금은 더 저렴하게!</h4>
                <p>타 보험에 비해 20~30% 이상 저렴(동일 조건 시)</p>
              </div>
            </div>
          </li>
          <li class="col-md-4 col-xs-12">
            <div class="card">
              <div class="card-index">02</div>
              <div class="card-img-box">
                <img src="~@/assets/svg/insurance/insurance-what-02.svg" class="img-responsive" alt="Solar power generation icon">
              </div>
              <div class="card-text-box">
                <h4>용량, 장소 상관없이 누구나!</h4>
                <p>10kW 이상 발전사업자라면 모두 가입 가능한 보험</p>
              </div>
            </div>
          </li>
          <li class="col-md-4 col-xs-12">
            <div class="card">
              <div class="card-index">03</div>
              <div class="card-img-box">
                <img src="~@/assets/svg/insurance/insurance-what-03.svg" class="img-responsive" alt="Natural disaster power plant icon">
              </div>
              <div class="card-text-box">
                <h4>자연재해까지 보장범위는 더 넓게!</h4>
                <p>천재지변까지 보상되는 유일한 발전사업자용 보험</p>
              </div>
            </div>
          </li>
        </ul>
        <ul class="row">
          <li class="col-md-3 col-xs-6">
            <div class="card-sub insurance-type-basic">
              <div class="orange-color">기본담보</div>
              <h4>재물손해</h4>
              <p>화재, 폭발, 도난, 자연재해 등 사고로 인한 태양광 설비 자체 손해</p>
            </div>
          </li>
          <li class="col-md-3 col-xs-6">
            <div class="card-sub insurance-type-basic">
              <div class="orange-color">기본담보</div>
              <h4>배상책임손해</h4>
              <p>설비 운영 중 제 3자의 신체 또는 재물에 발생한 법률상 배상책임 손해</p>
              <p class="margin-0">자연재해로 인한 제 3자 피해 포함</p>
            </div>
          </li>
          <li class="col-md-3 col-xs-6">
            <div class="card-sub insurance-type-rider">
              <div class="light-purple-color">선택담보(특약)</div>
              <h4>기업휴지손해</h4>
              <p>재물손해사고의 결과로 발전이 중단 또는 휴지되어 생긴 발전 상실 손해</p>
            </div>
          </li>
          <li class="col-md-3 col-xs-6">
            <div class="card-sub insurance-type-rider">
              <div class="light-purple-color">선택담보(특약)</div>
              <h4>원상복구비용</h4>
              <p>계약시 원상복구 의무 및 비용담보</p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="insurance-how">
      <div class="container text-center">
        <h2 class="content-title">이런 폭넓은 보장 <br>어떻게 가능할까?</h2>
        <p class="content-text margin-top-16">정부가 주관하는 정책성 보험이어서 가능합니다.</p>
        <div class="row">
          <div class="insurance-how-introduce col-xs-12">
            <img src="~@/assets/svg/insurance/insurance-how-introduce.svg" class="img-responsive" alt="Down price icon">
          </div>
        </div>
        <div class="row">
          <div class="insurance-how-apply col-md-push-6 col-md-6 col-xs-12">
            <h2 class="content-title">신청만 하면<br>편리한 절차를 통해 가입!</h2>
            <button type="button"
                    class="hz-btn-primary hz-btn-lg margin-top-40"
                    @click.prevent="apply">상담신청</button>
          </div>
          <div class="insurance-how-process col-md-pull-6 col-md-offset-1 col-md-5 col-xs-12">
            <div class="step-box">
              <div class="step-box-icon">
                <div class="orange-circle"></div>
                <div class="gray-line"></div>
              </div>
              <div class="step-box-text">
                <div>STEP 1</div>
                <h4>상담신청서 작성 또는 전화 문의</h4>
                <p>'상담신청' 클릭하여 신청서를 작성해주세요.</p>
              </div>
            </div>
            <div class="step-box">
              <div class="step-box-icon">
                <div class="orange-circle"></div>
                <div class="gray-line"></div>
              </div>
              <div class="step-box-text">
                <div>STEP 2</div>
                <h4>보험사 담당자 상담</h4>
                <p>전화로 궁금한 사항을 상세히 알려드립니다.</p>
              </div>
            </div>
            <div class="step-box">
              <div class="step-box-icon">
                <div class="orange-circle"></div>
                <div class="gray-line"></div>
              </div>
              <div class="step-box-text">
                <div>STEP 3</div>
                <h4>서류제출 및 가입</h4>
                <p>서류 제출 후 보험료를 납부하면 가입이 완료됩니다.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="faqList.length > 0" class="insurance-faq">
      <div class="container text-center">
        <h2 class="content-title">자주하는 질문</h2>
        <div class="row">
          <div class="col-md-offset-1 col-md-10 col-xs-12 text-left">
            <div class="card" v-for="faq in divisionFaqList[0]" :key="faq.id">
              <h4 class="faq-question"><em class="question-mark">Q</em>{{ faq.title }}</h4>
              <div class="faq-answer" v-html="faq.content"></div>
            </div>
          </div>
          <div v-if="divisionFaqList.length > 1" class="col-md-offset-1 col-md-10 col-xs-12 text-left">
            <div id="collapseFaq" class="card collapse" v-for="faq in divisionFaqList[1]" :key="faq.id">
              <h4 class="faq-question"><em class="question-mark">Q</em>{{ faq.title }}</h4>
              <div class="faq-answer" v-html="faq.content"></div>
            </div>
            <div class="col-xs-12 text-center">
              <a href="#collapseFaq" class="hz-btn-primary hz-btn-lg"
                 data-toggle="collapse" @click="moreBtnText">질문 더보기</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="applyList" v-if="user.id" class="insurance-list">
      <div class="container">
        <div class="row">
          <h4>신청목록</h4>
          <div v-if="user.auth_level === '90'">
            <label class="hz-checkbox">
              해줌 전체
              <input type="checkbox" v-model="companyAllCheck" @change="retrieveOthers()">
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col-xs-12 padding-0">
            <kendo-grid ref="grid"
                        :columns="tableFields"
                        :options="tableOptions"
                        :auth="true"
                        :dataUrl="applyListUrl"
                        :message="'신청내역이 없습니다.'">
            </kendo-grid>
          </div>
        </div>
      </div>
    </section>
    <!-- 전화문의 FAB -->
    <tel-fab :telNumber="'070-4756-4977'"></tel-fab>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import KendoGrid from 'common/components/KendoGrid'
  import Loader from 'common/components/Loader'
  import Modal from 'common/components/Modal'
  import TelFab from '@/components/TelFab'
  import api from '@/api/index'
  import eventHub from '@/shared/EventHub'

  export default {
    name: 'insurance',
    components: {
      KendoGrid,
      Loader,
      Modal,
      TelFab
    },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      divisionFaqList: function () {
        /**
         *  자주묻는 질문 목록을 최초 보여질 항목 3개, 더보기 버튼을 통해 보여질 항목으로 나누어 배열로 반환한다.
         *  자주묻는 질문 목록을 출력하는 영역에 최초 3개만 보여준다.
         *  그 이상의 목록은 더보기 버튼을 통해 보여준다.
         */

        const list = $.extend([], true, this.faqList)
        let divisionList = []

        // 자주묻는 질문 목록에서 3개단위로 잘라 첫번째 배열에 넣어준다.
        divisionList.push(list.splice(0, 3))

        // 최초 출력된 3개 자주묻는 질문 목록을 자른후에도 출력할 목록이 남아있다면 두번째 베열에 넣어준다.
        if (list.length > 0) {
          divisionList.push(list)
        }

        return divisionList
      }
    },
    data: function () {
      return {
        loaderActive: false,
        companyAllCheck: false,
        faqList: [],
        applyListUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/maintenance/insurance/',
        tableFields: [
          {
            field: 'reg_date',
            title: '신청일',
            type: 'date',
            format: '{0:yyyy.MM.dd}',
            width: '120px',
            sortable: false,
            filterable: false
          },
          {
            field: 'plant_name',
            title: '발전소명',
            type: 'string',
            width: '200px',
            sortable: false,
            filterable: false
          },
          {
            field: 'install_capacity',
            title: '용량(kWp)',
            type: 'string',
            width: '140px',
            sortable: false,
            filterable: false
          },
          {
            field: 'install_position',
            title: '설치위치',
            type: 'string',
            width: '140px',
            sortable: false,
            filterable: false
          },
          {
            field: 'install_type',
            title: '설치유형',
            type: 'string',
            width: '140px',
            sortable: false,
            filterable: false
          },
          {
            field: 'deduction_date',
            title: '공제보험 개시일자',
            type: 'date',
            format: '{0:yyyy.MM.dd}',
            width: '170px',
            sortable: false,
            filterable: false
          },
          {
            field: 'step',
            title: '진행단계',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false
          }
        ],
        tableOptions: {
          parameter: [
            { name: 'all_check', value: 'N' }
          ],
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            pageSize: 50,
            pageSizes: [20, 50, 100, 'all'],
            refresh: true,
            buttonCount: 5,
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          }
        }
      }
    },
    methods: {
      getFaq: function () {
        const vm = this
        const query = '?tag=insurance'

        // 자주묻는 질문을 불러온다.
        api.getFaq(query, response => {
          if (response.error) {
            // API 호출 실패 시
            console.log('fail get Notice!', response)
          } else {
            const results = response.hasOwnProperty('results') ? response.results : []

            // 등록된 자주묻는 질문이 있을 경우 데이터를 넣어준다.
            if (results.length > 0) {
              vm.faqList = results
            }

            // 자주묻는 질문이 렌더된 후 전달받은 파라미터가 있을 경우 보험신청 목록으로 스크롤을 이동한다.
            vm.$nextTick(() => {
              const params = vm.$route.params

              // 파라미터에 ID가 있을 경우 실행
              if (params.hasOwnProperty('id')) {
                // 전달받은 엘리먼트 ID로 스크롤을 이동하는 함수 실행
                vm.setScrollPosition(params.id)
              }
            })
          }
        })
      },
      apply: function () {
        const vm = this

        // 보험 신청하기 버튼 클릭 시, 로그인 여부에 따라 페이지 이동 또는 로그인 필요 알림처리
        if (vm.user.id) {
          vm.$router.push({name: 'insuranceApply'})
        } else {
          eventHub.$emit('showLoginModal')
        }
      },
      moreBtnText: function (event) {
        const target = event.target
        const text = target.text

        // 현재 버튼의 텍스트 상태값을 변경하여 넣어준다.
        event.target.text = text === '질문 더보기' ? '닫기' : '질문 더보기'
      },
      setScrollPosition: function (id = '') {
        // 해당 ID를 가진 엘리먼트로 스크롤을 이동시킨다.
        if (id) {
          const body = $('body')
          const el = $('section[id="' + id + '"]')
          const innerWidth = body.innerWidth()

          // 현재 창의 크기에 따른 헤더의 높이를 계산하여 빼준다.
          let headerHeight = innerWidth > 991 ? 72 : 56
          let position = (body.scrollTop() + el.offset().top) - headerHeight

          if (el && typeof el !== 'undefined') {
            $('html,body').stop().animate({scrollTop: (position)}, 500)
          }
        }
      },
      retrieveOthers: function () {
        const vm = this
        const isAll = vm.companyAllCheck ? 'Y' : 'N'

        // 보고서 전체보기 클릭 여부에 따라 목록 API Parameter를 설정해준다.
        vm.tableOptions.parameter = [
          {name: 'all_check', value: isAll}
        ]

        // 보고서 목록 업데이트
        vm.$refs.grid.refresh()
      }
    },
    created: function () {
      // 자주묻는 질문 목록 불러오기
      this.getFaq()
    },
    mounted: function () {
    }
  }
</script>

<style lang="scss" scoped>
  $insurance-font-color: #2e3134;
  $insurance-sub-font-color: #54595f;
  $orange-color: #ff7133;
  $light-purple-color: #9b88e9;

  #insurance {
    word-break: keep-all;

    ul, li {
      list-style: none;
    }

    .content-title {
      margin: 0;
      font-size: 32px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.23;
      letter-spacing: -1.4px;
      text-align: center;
      color: $insurance-font-color;

      @media (max-width: 767px) {
        font-size: 26px;
      }
    }

    .hz-btn-primary {
      width: 167px;
    }

    .content-text {
      margin: 0;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.71;
      letter-spacing: -0.7px;
      text-align: center;
      color: $insurance-sub-font-color;

      br {
        display: none;
      }
    }

    .insurance-banner {
      position: relative;
      padding: 116px 0;
      background-image: url("~@/assets/img/bg-insurance-banner.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 100%;

      .title {
        margin: 0;
        padding: 0 16px;
        font-size: 48px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: -2.9px;
        color: $hzc-white;
      }

      .hz-btn-lg {
        margin-top: 46px;
      }

      @media (max-width: 991px) {
        .title {
          font-size: 36px;
        }
      }

      @media (max-width: 767px) {
        padding: 76px 0;
        .title {
          font-size: 32px;
        }
        .hz-btn-lg {
          margin-top: 24px;
        }
      }

      @media (max-width: 375px) {
        .title {
          width: 240px;
          margin: auto;
          padding: 0;
          br {
            display: none;
          }
        }
      }
    }

    .insurance-why {
      padding: 87px 0 75px 0;

      .content-text {
        margin: 8px 0 48px 0;
      }

      .card {
        padding: 16px 24px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
        overflow: auto;

        &-img-box {
          display: inline-block;
          height: 90px;
          width: 104px;
        }

        &-text-box {
          display: inline-block;
          width: calc(100% - 104px);
          padding-top: 24px;
          padding-left: 8px;
          text-align: left;
          float: right;

          p {
            margin: 0;
            font-size: 16px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.5;
            letter-spacing: -1.3px;
            color: $insurance-font-color;
          }
        }
      }

      @media (max-width: 1199px) {
        .card-text-box {
          padding-top: 8px;
        }
        br {
          display: none;
        }
      }

      @media (max-width: 991px) {
        padding: 48px 8px 24px;

        .content-text {
          margin: 8px 0 40px 0;
        }

        .card {
          margin-bottom: 16px;
        }

        .card-text-box {
          padding-top: 36px;
        }
      }

      @media (max-width: 532px) {
        .card-text-box {
          padding-top: 24px;
        }
        br {
          display: block;
        }
      }

      @media (max-width: 467px) {
        .content-title {
          width: 240px;
          margin: auto;
        }

        .content-text {
          margin-top: 16px;
        }
      }

      @media (max-width: 352px) {
        .card-text-box {
          padding: 0;
        }
      }
    }

    .insurance-what {
      padding: 103px 0 75px 0;
      background-color: $light-grey;

      .content-title {
        margin-bottom: 48px;
      }

      .card-wrap {
        margin-bottom: 56px;
      }

      .card {
        &-index {
          width: 16px;
          margin: 0 auto 24px;
          font-weight: bold;
          padding-bottom: 8px;
          border-bottom: 3px solid $orange-color;
        }

        &-img-box {
          margin-bottom: 8px;

          img {
            margin: auto;
          }
        }

        &-text-box {
          h4 {
            margin: 0;
            font-size: 22px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.18;
            letter-spacing: -1.1px;
            text-align: center;
            color: $insurance-font-color;
          }

          p {
            margin: 8px 0 0 0;
            font-size: 16px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.5;
            letter-spacing: -0.8px;
            text-align: center;
            color: $insurance-font-color;
          }
        }
      }

      .card-sub {
        min-height: 232px;
        padding: 32px 24px;
        background-color: $hzc-white;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
        text-align: left;

        div {
          margin-bottom: 24px;
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.33;
          letter-spacing: -0.3px;
        }

        h4 {
          margin: 0 0 8px 0;
          font-size: 16px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: -1.3px;
          color: $insurance-font-color;
        }

        p {
          margin: 0 0 24px 0;
          font-size: 14px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.71;
          letter-spacing: -0.7px;
          color: $insurance-sub-font-color;
        }

        .orange-color {
          color: $orange-color;
        }

        .light-purple-color {
          color: $light-purple-color;
        }
      }

      @media (min-width: 992px) and (max-width: 1199px) {
        .card-sub {
          min-height: 252px;
        }
      }

      @media (max-width: 991px) {
        padding: 80px 8px;

        .card {
          margin-bottom: 40px;
        }

        .card-sub {
          margin-bottom: 16px;
        }
      }

      @media (max-width: 767px) {
        .card-sub {
          padding: 32px 16px;
          p {
            margin: 0 0 16px 0;
          }
        }

        .insurance-type-basic {
          min-height: 272px;
        }

        .insurance-type-rider {
          min-height: 232px;
          p {
            margin: 0;
          }
        }
      }

      @media (max-width: 356px) {
        .insurance-type-basic {
          min-height: 312px;
        }
      }
    }

    .insurance-how {
      padding: 86px 0 69px 0;

      .content-title br {
        display: none;
      }

      &-introduce {
        padding: 32px 0 48px 0;
        img {
          margin: auto;
        }
      }

      &-apply {
        padding-top: 125px;
        text-align: left;

        .content-title {
          font-weight: normal;
          text-align: left;
        }

        @media (max-width: 991px) {
          text-align: center;
          .content-title {
            text-align: center;
          }
        }
      }

      &-process {
        padding-left: 65px;

        .step-box {
          position: relative;
          height: 144px;
          width: 100%;
          margin-bottom: 16px;
        }

        .step-box-icon {
          display: inline-block;
          height: 100%;
          width: 8px;
          text-align: center;
          float: left;
        }

        .step-box-text {
          display: inline-block;
          width: calc(100% - 16px);
          padding: 16px;
          text-align: left;

          div {
            margin-bottom: 16px;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.33;
            letter-spacing: -0.3px;
            color: $insurance-sub-font-color;
          }

          h4 {
            margin: 0 0 16px 0;
            font-size: 20px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: -0.9px;
            color: $insurance-font-color;
          }

          p {
            margin: 0;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.71;
            letter-spacing: -0.7px;
            color: $insurance-sub-font-color;
          }
        }

        .orange-circle {
          height: 8px;
          width: 8px;
          margin-bottom: 8px;
          border: 1px solid $orange-color;
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
        }

        .gray-line {
          display: inline-block;
          height: calc(100% - 16px);
          width: 1px;
          border-left: 1px solid $hzc-gray-05;
        }
      }

      @media (max-width: 991px) {
        padding: 75px 16px 18px;

        &-apply {
          padding: 60px 0 48px 0;
        }
      }

      @media (max-width: 467px) {
        .content-title br {
          display: block;
        }

        &-process  {
          padding: 0;
        }
      }
    }

    .insurance-faq {
      padding: 93px 0;
      background-color: $light-grey;

      .row {
        margin-bottom: 24px;
      }

      .content-title {
        margin-bottom: 96px;
      }

      .hz-btn-primary {
        margin-top: 32px;
        padding: 14px 16px;
      }

      .faq-question {
        margin: 0 0 14px 0;
        font-size: 20px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: -0.9px;
        color: $insurance-font-color;
      }

      .question-mark {
        padding: 0 24px 0 0;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: -1.1px;
        color: #ff7133;
      }

      .faq-answer {
        padding: 0 0 38px 40px;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.71;
        letter-spacing: -0.7px;
        color: $insurance-sub-font-color;
      }

      @media (max-width: 991px) {
        padding: 80px 8px;
      }
    }

    .insurance-list {
      padding: 60px 16px;

      h4 {
        margin: 0 0 48px 0;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: -1.1px;
        color: $insurance-font-color;
      }

      @media (max-width: 767px) {
        padding: 40px 16px;
        h4 {
          margin: 0 0 24px 0;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/onm/Insurance.vue